import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    hardwoodRemaining: 0,
    cedarRemaining: 0,
    blackRemaining: 0,
    redRemaining: 0,
    totalBagsSold: 0
};

const fetchOrdersSummarySuccess = ( state, action ) => {
    return updateObject( state, {
        hardwoodRemaining : action.hardwoodRemaining,
        cedarRemaining : action.cedarRemaining,
        blackRemaining : action.blackRemaining,
        redRemaining: action.redRemaining,
        totalBagsSold : action.totalBagsSold
    } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
       case actionTypes.FETCH_ORDERSSUMMARY_SUCCESS: return fetchOrdersSummarySuccess( state, action );
       default: return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/ordersSummary.js